import * as angular from "angular";
import {IController} from "angular";

export class EditResourceAllocationDialogViewComponent implements IController {

  data: any;
  onDataChange: Function;

  constructor() {
  }

  onRangeChange(from, to) {
    this.data.schedule.startTime = from;
    this.data.schedule.endTime = to;
    this.onDataChange({data: this.data});
  }

}

angular
  .module('bringoz.admin.resources')
  .component('editResourceAllocationDialogView', {
    require: {
      form: '^form'
    },
    bindings: {
      data: '<',
      onDataChange: '&'
    },
    template: require('./edit-resource-allocation-dialog-view.html').default,
    controller: EditResourceAllocationDialogViewComponent
  });
